// extracted by mini-css-extract-plugin
export default {"button":"white-micro-icon__button___nvZo5 white-micro__button___mkS1I primary-micro__button___-C-FY primary__button___frFdc base__button___zT0JW"};